import { fetchResultAd } from '../services/api'
import { getResultText } from '../utils/utils'

const types = {
  SET_LOAD_STATUS: 'SET_LOAD_STATUS',
  SET_DATA: 'SET_DATA'
}

export const actions = {
  setLoadStatus(status) {
    return { type: types.SET_LOAD_STATUS, payload: status }
  },
  setData(data) {
    return { type: types.SET_DATA, payload: data }
  },
  fetchAdData() {
    return async (dispatch, getState) => {
      const {
        test: { runtime },
        app: { testType }
      } = getState()
      const { score = 9527 } = runtime || {}
      try {
        const rawData = await fetchResultAd(testType, score)
        if (rawData.code === 1) {
          const { end_text, img_ads } = rawData.data
          const subject = end_text || getResultText(testType, score)
          dispatch(
            this.setData({
              subject,
              banners: img_ads || []
            })
          )
          dispatch(this.setLoadStatus(true))
        } else {
          throw new Error(rawData.message)
        }
      } catch (err) {
        console.log(err)
        dispatch(
          this.setData({
            subject: getResultText(testType, score),
            banners: []
          })
        )
        dispatch(this.setLoadStatus(true))
      }
    }
  }
}

const initialState = {
  isLoaded: false,
  subject: '',
  banners: []
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case types.SET_LOAD_STATUS:
      return {
        ...state,
        isLoaded: action.payload
      }
    case types.SET_DATA:
      return {
        ...state,
        ...action.payload
      }
    default:
      return state
  }
}
